import { useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { Alert } from '@treezor/design-system';

import { logout } from '@/store/actions/auth.actions';
import { useRoutepaths } from '@/router/hooks/useRoutePaths';

import { useAlert } from './useAlert';

export function LogoutAlert() {
  const { dispatch, t, handleAlertClose, alertClasses } = useAlert('logoutWarning');
  const navigate = useNavigate();
  const PathRoute = useRoutepaths();

  const handleLogout = useCallback(() => {
    dispatch(logout());
    navigate(generatePath(PathRoute.auth.root, { '*': PathRoute.auth.signIn }));
  }, [dispatch, navigate, PathRoute.auth.root, PathRoute.auth.signIn]);

  return (
    <Alert
      title={t('components.molecules.logOutAlert.error.label')}
      description={t('components.molecules.logOutAlert.error.description')}
      isClosable
      variant="secondary"
      type="danger"
      onClose={handleAlertClose}
      className={alertClasses}
      action={{
        title: t('components.molecules.logOutAlert.error.action'),
        onClick: handleLogout,
      }}
    />
  );
}
